import {Flex, Text, TextColor} from '@priority-software/priority-style-react';
import React from 'react';
import {FeatureLabel} from '../FeatureLabel';
import {texts} from '../../../AdvancedSearch/AdvancedSearchDrawer/texts';
import {ModernTooltip} from '../../../../../../components/Common/Tooltip/ModernTooltip';
import styles from './styles.module.scss';

type Props = {
    planning?: boolean;
    text: React.ReactNode;
    textColor: TextColor | undefined;
    tooltip?: string;
    tooltipZindex?: number;
};

export const ContextMenuItemContent = (props: Props) => {
    const {planning, text, textColor, tooltip, tooltipZindex} = props;

    const content = (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            componentClasses={styles.itemContent}
        >
            <Text textColor={textColor} wrap={false}>
                {text}
            </Text>
            {planning ? <FeatureLabel text={texts.featurePlannedLabel} /> : null}
        </Flex>
    );

    return tooltip ? (
        <ModernTooltip
            zIndex={tooltipZindex}
            position="top"
            delay={500}
            wrapperClassname={styles.itemWithTooltip}
            tooltip={tooltip}
        >
            {content}
        </ModernTooltip>
    ) : (
        content
    );
};
